// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".8554a4d93324e9f3abd3dc2ef8a3fb38.js";
};